export const colors = {
    primary: "#4a4aff",
    secondary: "#27E4D1",
    secondaryText: "#1E3A8A",
    basicText: "#000",
    dark: "#17120F",
    blue: "#2563EB",
};
